import {AxiosResponse} from 'axios'

import {Property} from '@/api/properties'

import { api } from '@/helpers/core'

interface Entity {
	id: string
	value: any
	txIds: any[]
}

export default {
	definitions (): Promise<AxiosResponse<string[]>> {
		return api.get('/graph/definitions/')
	},
	addDefinitions (ids: string[]): Promise<AxiosResponse<string[]>> {
		return api.post('/graph/definitions/', ids)
	},
	removeDefinitions (ids: string[]): Promise<AxiosResponse<string[]>> {
		return api.post('/graph/definitions/remove', ids)
	},
	init ({ definitionName, value }: { definitionName: string, value?: string }): Promise<AxiosResponse<Entity>> {
		return api.get('/graph/items/' + encodeURIComponent(definitionName) + '/' + encodeURIComponent(value || '') + '/')
	},
	neighbors ({ sourceId, targetName }: { sourceId: string, targetName: string }): Promise<AxiosResponse<Entity[]>> {
		return api.post('/graph/items/', { sourceId, targetName })
	},
	txData ({ txIds, properties }: { txIds: string[], properties: Property[] }) {
		return api.post('/graph/tx_data/', { txIds, projection: properties.map((p) => p.path) })
	}
}
